"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientAccountPage = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../app");
const client_account_1 = require("../../model/client_account");
const helpers_1 = require("../../utils/helpers");
const form_for_1 = require("../../widgets/form_for");
const notification_center_1 = require("../../widgets/notification_center");
let account = {};
let currentPage = renderPersonal;
let hardware = [];
function renderPersonal() {
    return (0, form_for_1.formFor)(account, client_account_1.ClientAccountProvider, (form) => {
        return (0, helpers_1.card)(undefined, (0, mithril_1.default)("div", { key: "perso" }, (0, mithril_1.default)("h3", "Informations de compte"), (0, mithril_1.default)("hr"), form.errorBlock(), (0, form_for_1.columns)(form.field("Prénom", "first_name", "text"), form.field("Nom", "last_name", "text")), (0, form_for_1.columns)(form.field("E-mail", "email", "email"), form.field("Telephone", "cellphone", "text"), form.field("Portable", "cellphone", "text")), (0, helpers_1.level)({ right: form.submit("Enregistrer", { onsubmit: () => { notification_center_1.Notification.info("Vos informations ont été mises à jour!"); } }) })));
    });
}
function renderCompany() {
    return (0, form_for_1.formFor)(account, client_account_1.ClientAccountProvider, (form) => {
        return (0, helpers_1.card)(undefined, (0, mithril_1.default)("div", { key: "company" }, form.errorBlock(), (0, mithril_1.default)("h3", "Informations légales"), (0, mithril_1.default)("hr"), form.field("Raison sociale", "company_name", "text"), (0, form_for_1.columns)(form.field("Profession", "job_title", "text"), form.selectField("Statut", "legal_status", app_1.App.CLIENT_TYPE), form.field("SIRET", "siret", "text")), form.textarea("Adresse", "address"), (0, form_for_1.columns)(form.field("Code postal", "postal_code", "text"), form.field("Ville", "city", "text")), (0, mithril_1.default)("h3", "Adresse de facturation"), (0, mithril_1.default)("hr"), (0, mithril_1.default)("p", { style: "font-size: 1em; font-style: italic;" }, "Laissez vide si meme adresse que votre société"), form.textarea("Adresse", "invoicing_address"), (0, form_for_1.columns)(form.field("Code postal", "invoicing_postal_code", "text"), form.field("Ville", "invoicing_city", "text")), (0, helpers_1.level)({ right: form.submit("Enregistrer", { onsubmit: () => { notification_center_1.Notification.info("Vos informations ont été mises à jour!"); } }) })));
    });
}
function renderSecurity() {
    return (0, form_for_1.formFor)(account, client_account_1.ClientAccountProvider, (form) => {
        return (0, helpers_1.card)(undefined, (0, mithril_1.default)("div", { key: "security" }, (0, mithril_1.default)("h3", "Changement de mot de passe"), (0, mithril_1.default)("hr"), form.errorBlock(), form.field("Mot de passe actuel", "current_password", "password"), form.field("Nouveau mot de passe", "new_password", "password"), form.field("Nouveau mot de passe (confirmation)", "new_password_confirmation", "password"), (0, helpers_1.level)({ right: form.submit("Enregistrer", { onsubmit: () => { notification_center_1.Notification.info("Vos informations ont été mises à jour!"); } }) })));
    });
}
function addPreferredHardware(v) {
    const d = account.default_hardware;
    if (d.indexOf(v) == -1)
        d.push(v);
}
function removePreferredHardware(v) {
    const d = account.default_hardware;
    let idx = d.indexOf(v);
    if (idx != -1)
        d.splice(idx, 1);
}
function renderPreferences() {
    return (0, form_for_1.formFor)(account, client_account_1.ClientAccountProvider, (form) => {
        const hardware_map = {};
        form.obj.default_hardware.forEach((val) => hardware_map[val] = true);
        return (0, helpers_1.card)(undefined, form.fieldset("Préférences", (0, form_for_1.columns)(form.checkbox("Recevoir les e-mails de confirmation de réservation", "send_email_confirm_booking")), (0, mithril_1.default)("hr"), (0, mithril_1.default)("h3", "Matériel présélectionné"), (0, mithril_1.default)("p", { style: "font-size: 0.8em; font-style: italic;" }, "Lors des prochaines réservations, le matériel coché sera automatiquement présélectionné"), (0, form_for_1.columns)(...hardware.map(h => (0, form_for_1.checkbox)(h, h, hardware_map, {
            value: h, oninput: (e) => {
                e.target.checked ?
                    addPreferredHardware(e.target.value) :
                    removePreferredHardware(e.target.value);
            }
        }))), (0, helpers_1.level)({ right: form.submit("Enregistrer", { onsubmit: () => { notification_center_1.Notification.info("Vos informations ont été mises à jour!"); } }) })));
    });
}
function renderForm() {
    return (0, mithril_1.default)(".columns", { style: "margin: 0" }, (0, mithril_1.default)(".column.is-one-quarter", (0, helpers_1.panel)({
        title: "Mon compte",
        content: [
            (0, helpers_1.panelBlock)({
                content: "Personnel",
                icon: "fa-user",
                tag: "a",
                isActive: currentPage == renderPersonal,
                attrs: {
                    href: "#", onclick: (e) => {
                        e.preventDefault();
                        currentPage = renderPersonal;
                    }
                }
            }),
            (0, helpers_1.panelBlock)({
                content: "Société",
                icon: "fa-building",
                tag: "a",
                isActive: currentPage == renderCompany,
                attrs: {
                    href: "#", onclick: (e) => {
                        e.preventDefault();
                        currentPage = renderCompany;
                    }
                }
            }),
            (0, helpers_1.panelBlock)({
                content: "Sécurité",
                icon: "fa-lock",
                tag: "a",
                isActive: currentPage == renderSecurity,
                attrs: {
                    href: "#", onclick: (e) => {
                        e.preventDefault();
                        currentPage = renderSecurity;
                    }
                }
            }),
            (0, helpers_1.panelBlock)({
                content: "Préférences",
                icon: "fa-star",
                tag: "a",
                isActive: currentPage == renderPreferences,
                attrs: {
                    href: "#", onclick: (e) => {
                        e.preventDefault();
                        currentPage = renderPreferences;
                    }
                }
            })
        ],
        attrs: {
            class: "container is-primary",
            style: "margin-top: 2em"
        }
    })), (0, mithril_1.default)(".column", (0, mithril_1.default)(".content", { style: "padding: 1em;" }, currentPage(), (0, mithril_1.default)("div", { style: "padding-bottom: 3em;" }) // Some padding
    )));
}
exports.ClientAccountPage = {
    oncreate() {
        return __awaiter(this, void 0, void 0, function* () {
            client_account_1.ClientAccountProvider.show(0).then((x) => { account = x; });
            hardware = yield app_1.App.get("/rooms/avail_hardware");
        });
    },
    view() {
        return (0, mithril_1.default)(".container", renderForm());
    }
};
